<script setup lang="ts">
import { cva, type VariantProps } from 'class-variance-authority'

const fillVariants = cva('', {
  variants: {
    variant: {
      primary: 'fill-highlight-primary-accent',
      secondary: 'fill-highlight-secondary-accent',
      tertiary: 'fill-highlight-tertiary-accent',
      quarternary: 'fill-highlight-quarternary-accent'
    }
  },
  defaultVariants: {
    variant: 'tertiary'
  }
})

const svgSizeVariants = cva('w-[24px] h-[38px] sm:w-[28px] sm:h-[44px] md:w-[32px] md:h-[50px] lg:w-[55px] lg:h-[86px]')

export type SectionHeadingShapeProps = VariantProps<typeof fillVariants> & VariantProps<typeof svgSizeVariants>

defineProps<{
  variant?: SectionHeadingShapeProps['variant'],
}>()
</script>

<template>
  <div>
    <slot />
    <svg xmlns="http://www.w3.org/2000/svg"
         :class="svgSizeVariants()"
         viewBox="0 0 24 38"
         fill="none">
      <path d="M0 0L24 4.63784V33.3622L0 38V0Z"
            :class="fillVariants({ variant })" />
    </svg>
  </div>
</template>
